<template>
  <div class="list-container">

    <div class="back-btn" @click="handleBackClick">
      <van-image
        v-if="isFromPermission"
        class="button-icon"
        :src="require('@/assets/image/ic_back.png')"
      />
    </div>
    <!--    List-->
    <div class="terms-container">
      <div class="legal-protocol">
        <div class="title">POLÍTICA DE PRIVACIDAD</div>
        <div class="desc">
          De conformidad con el Reglamento (UE) 2016/679 del Parlamento Europeo
          y del Consejo de 27 de abril de 2016 ("GDPR") y la Ley Orgánica
          3/2018, de 5 de diciembre, de Protección de Datos Personales y
          garantía de los derechos digitales, le informamos sobre el tratamiento
          de sus datos:
        </div>

        <div class="desc-li">1. Responsable de los datos</div>

        <div class="desc">
          Nombre de la empresa "Nébula Finance, S.A." nombre comercial de nuestra App "PrestaLight", con CIF: A75607945 y domicilio social en Paseo De
          La Castellana 194 - Madrid - 28046 (en adelante "Nébula" y/o
          "nosotros"), es responsable del tratamiento de sus datos.
        </div>
        <div class="desc">
          Nébula Finance, S.A., como responsable del tratamiento, dispone de los
          medios técnicos, organizativos y humanos necesarios para garantizar la
          seguridad y protección de sus sistemas de información, así como de los
          datos e información almacenados en los mismos.
        </div>
        <div class="desc">
          Nébula Finance, S.A. ha designado un Delegado de Protección de Datos
          (en adelante, DPD o DPO) para atender cualquier consulta o duda
          relacionada con la presente Política de Privacidad o con el
          tratamiento de los datos personales de los interesados o afectados por
          Nébula.
        </div>
        <div class="desc">
          Puede ponerse en contacto con el DPD con sus sugerencias, consultas o
          quejas en la siguiente dirección de correo electrónico:
          <span class="mark-text">dpo@prestalight.com</span>
        </div>

        <div class="desc-li">
          2. ¿Qué permisos concede a Nébula en su dispositivo?
        </div>

        <ol class="protocol-list protocol-list-unordered">
          <li v-if="!isIOS">
            Recopilamos datos de localización aproximados de su dispositivo para
            mitigar los posibles riesgos asociados a su cuenta y mejorar la
            seguridad de sus datos. Todos los datos se cifran para salvaguardar
            la confidencialidad. Los datos se transmitirán y almacenarán de
            forma segura en nuestros servidores a través de una conexión
            protegida.
          </li>
          <li>
            Para garantizar el correcto procesamiento de nuestros servicios,
            necesitamos acceder a la cámara de su dispositivo. Se le pedirá que
            cargue fotos de su DNI y una foto facial para completar los pasos
            necesarios para la verificación KYC. Le confirmamos que no
            accederemos ni almacenaremos ninguna otra foto o vídeo en su
            dispositivo. Tenga en cuenta que, sin su consentimiento, no podremos
            prestar los servicios mencionados ni actualizarlos.
          </li>
          <li v-if="!isIOS">
            Con tu permiso, accedemos únicamente a tus mensajes financieros
            (remitente, fecha y contenido). Usamos esta información para evaluar
            tu situación financiera, determinar si puedes obtener un préstamo y
            prevenir fraudes. Los mensajes se transmiten y almacenan a través de
            nuestros servidores seguros (https://www.prestalight.com/).
            Cumplimos con la normativa vigente y nuestras políticas de
            privacidad para proteger tus datos. No accedemos a mensajes no
            relacionados ni compartimos tus datos con terceros. Puedes activar o
            desactivar este permiso en cualquier momento desde la configuración.
          </li>
          <li>
            Con el fin de optimizar su experiencia de servicio y proporcionarle
            notificaciones importantes, alertas de seguridad y actualizaciones
            de funciones, necesitamos su permiso para activar las
            notificaciones. Usted puede elegir si desea conceder permisos de
            notificación. Si decide desactivar las notificaciones, dejará de
            recibir relacionados mensajes, sin embargo, esto no afectará al
            funcionamiento normal de la aplicación.
          </li>
          <li v-if="!isIOS">
            Podemos recopilar información básica sobre las aplicaciones
            instaladas en su dispositivo, incluyendo si la aplicación está
            preinstalada por el sistema, el nombre de la aplicación, el número
            de versión y las fechas de instalación inicial y de la actualización
            más reciente. Sin embargo, sólo procesaremos los datos necesarios
            para aplicaciones específicas. Esta información se utiliza para
            identificar posibles riesgos, prevenir actividades fraudulentas y
            garantizar la seguridad de su cuenta y sus fondos.
          </li>
          <li>
            Podemos solicitar permiso para acceder al estado Wifi de su
            dispositivo para identificar las características del entorno de red,
            lo que nos ayuda a facilitar las evaluaciones de riesgo y detectar
            anomalías en la red, garantizando el funcionamiento seguro y estable
            del servicio.
          </li>
          <li>
            Podemos solicitar permiso para acceder al estado y tipo de conexión
            de red de su dispositivo. Esto permite supervisar en tiempo real la
            calidad de la red, lo que nos ayuda a mitigar el riesgo de
            interrupciones de datos y optimizar la estabilidad y seguridad del
            servicio.
          </li>
          <li v-if="!isIOS">
            Podemos solicitar permiso para acceder al identificador de
            publicidad de Google (GAID) con el fin de analizar los datos de
            interacción publicitaria y optimizar la relevancia de la orientación
            de los anuncios. Puede inhabilitar el seguimiento personalizado de
            anuncios en cualquier momento a través de la configuración de
            preferencias de publicidad de su dispositivo.
          </li>
        </ol>
        <div class="desc-li">3. ¿Qué datos se tratan por Nébula?</div>
        <div class="desc">
          Los datos personales que trataremos para poder prestarle el servicio y
          que serán tratados exclusivamente para los fines descritos a
          continuación son:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Datos básicos de identificación: Nombre, apellidos, sexo, DNI/NIE o
            documento similar que acredite la identidad.
          </li>
          <li>
            Datos de contacto: número de teléfono, segundo número de teléfono de
            contacto adicional (opcional), dirección postal, dirección de correo
            electrónico.
          </li>
          <li>
            Datos sobre circunstancias personales: fecha de nacimiento, lugar de
            nacimiento, descripción personal.
          </li>
          <li>
            Datos económicos y financieros: Datos bancarios, número de tarjeta
            de crédito, número de cuenta bancaria, ingresos o rentas mensuales,
            próxima fecha de pago, gasto medio mensual, número de cuentas
            bancarias, saldos de cuentas bancarias, nombre del beneficiario de
            la cuenta bancaria, fechas de pago, historial bancario
          </li>
          <li>
            Información disponible en los ficheros de solvencia y crédito.
          </li>
          <li>
            Datos del empleo: situación laboral, empresa actual, nivel máximo de
            estudios, cargo, fecha de inicio del último empleo, sector de
            actividad.
          </li>
          <li>
            Datos de productos y/o servicios contratados: productos y/o
            servicios previamente solicitados por el Usuario.
          </li>
          <li>
            Datos de navegación: Dirección IP, datos del dispositivo del Usuario
            (por ejemplo, tipo de dispositivo, tipo de navegador), tiempo de
            navegación, duración de la navegación en nuestra web y app.
          </li>
          <li>
            Datos de terceros: número de personas a cargo, relación con el
            usuario.
          </li>
          <li>
            Perfil adicional relacionado con el uso de la aplicación móvil y el
            dispositivo utilizado: Podemos recopilar datos genéricos de
            localización, dirección IP, detalles de hardware y software, ID de
            sesión e información del dispositivo (incluyendo tipo, versión,
            modelo y sistema operativo), así como detalles de la solicitud.
            Además, podemos recopilar datos relacionados con los servicios de
            conexión, geolocalización en tiempo real durante el uso de nuestra
            aplicación móvil aplicación móvil en teléfonos inteligentes y
            geolocalización móvil durante el uso de la aplicación. Esto incluye
            información sobre las características y el estado del dispositivo
            móvil, detalles del software, así como la conexión y el uso de
            Internet. Los datos mencionados se recogerán para fines relacionados
            con el crédito solicitado y/o para obtener datos estadísticos.
          </li>
          <li>
            Datos biométricos: con su consentimiento previo, y con la finalidad
            de entrar en un sistema de identificación online, recogeremos una
            imagen de su documento nacional de identidad, una fotografía o
            'selfie', así como datos de reconocimiento facial, y una grabación
            de voz para mantener un registro de las llamadas telefónicas que
            mantengamos con usted. Dichos datos se recogerán para fines
            relacionados con el préstamo que ha solicitado y en cumplimiento de
            las obligaciones de diligencia debida establecidas por la normativa
            vigente.
          </li>
        </ul>
        <div class="desc-li">4. ¿Cómo se obtienen sus datos personales?</div>
        <div class="desc">
          Podemos recabar su información a través de medios lícitos, incluidos
          directamente de usted o de terceros a través de plataformas
          electrónicas, aplicaciones móviles y/o sitios web propios o de
          terceros. En concreto, podemos obtener información a través de los
          siguientes canales:
        </div>
        <div class="subtitle">Directamente del interesado a través de:</div>
        <ul class="protocol-list protocol-list-unordered">
          <li>Formularios en línea situados en la página principal;</li>
          <li>Navegación web y uso de cookies;</li>
          <li>Correos electrónicos;</li>
          <li>Llamadas telefónicas;</li>
          <li>Otros medios de comunicación a distancia;</li>
          <li>WhatsApp;</li>
          <li>Mensajes de texto;</li>
          <li>La aplicación móvil.</li>
        </ul>

        <div class="subtitle">
          De terceros distintos del interesado, a través de:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>Sistemas de información crediticia;</li>
          <li>
            Terceros afiliados, proveedores de servicios de redirección y
            comparadores de microcréditos durante el proceso de solicitud de
            préstamo;
          </li>
          <li>
            Proveedores de servicios de pago, en particular UNNAX cuando utiliza
            el servicio de agregación de información de cuentas ("open
            banking");
          </li>
          <li>
            Familiares, conocidos y/o amigos suyos, en caso de que faciliten
            dicha información a través de nuestro servicio de atención al
            cliente y/o proceso de cobro;
          </li>
          <li>Otras empresas del grupo;</li>
          <li>Fuentes de acceso público (por ejemplo, Google).</li>
        </ul>

        <div class="desc">
          Al enviar sus Datos Personales en nuestro sitio web o aplicación
          móvil, usted garantiza que la información es exacta, veraz y libre de
          cualquier intención fraudulenta o errónea.
        </div>
        <div class="desc">
          De acuerdo con el principio de exactitud, actualizaremos la
          información de su base de datos basándonos en los datos recogidos
          directamente de usted o de terceros.
        </div>

        <div class="desc-li">
          5. ¿Qué ocurre si no proporciono todos los datos solicitados?
        </div>
        <div class="desc">
          La negativa a facilitar todos los datos identificativos y de contacto,
          así como los relativos a su renta o solvencia señalados como
          obligatorios, podrá tener como consecuencia la imposibilidad de
          acceder al servicio que pretenda contratar o, en su caso, de atender
          sus solicitudes.
        </div>
        <div class="desc">
          Asimismo, el usuario garantiza que todos los datos que facilites a
          Nebula durante el proceso de solicitud y a lo largo de la relación
          contractual son exactos, completos, actuales y te pertenecen. Usted
          reconoce que no es responsable de ningún daño o perjuicio directo o
          indirecto derivado del incumplimiento de esta obligación. En el caso
          de que facilites datos de terceros, confirmas que has obtenido su
          consentimiento y aceptas compartir la información contenida en esta
          Política de Privacidad, eximiendo así a Nébula de cualquier
          responsabilidad al respecto. No obstante, Nébula se reserva el derecho
          a realizar las comprobaciones necesarias para confirmar este extremo,
          de conformidad con la normativa aplicable en materia de protección de
          datos, y aplicará las medidas de diligencia debida oportunas.
        </div>
        <div class="desc">
          Los datos facilitados son imprescindibles para la gestión y ejecución
          del contrato. Usted está obligado a mantener esta información
          actualizada durante toda la duración de la relación contractual para
          garantizar una gestión adecuada. Usted se compromete a notificarnos
          sin demora cualquier modificación o rectificación de sus datos
          personales.
        </div>

        <div class="desc">
          6. ¿Con qué finalidad se tratan sus datos personales?
        </div>
        <div class="desc">
          La finalidad principal del tratamiento de sus datos es la prestación
          de los servicios contratados y, con carácter previo a la concesión de
          un préstamo, el estudio y evaluación de las solicitudes presentadas.
          Esto es necesario para establecer, ejecutar y mantener la relación
          contractual entre usted y Nébula:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Gestionar y tramitar las peticiones y/o solicitudes realizadas por
            el Usuario, incluyendo todas las dudas, consultas, quejas y/o
            reclamaciones que el Usuario pueda plantear a través de cualquiera
            de los canales habilitados al efecto, incluido el telefónico.
          </li>
          <li>
            Gestión y tramitación de la solicitud de préstamo, incluidas las
            comprobaciones preliminares necesarias para aprobar el préstamo en
            línea, incluido el análisis de la solvencia, el riesgo y la
            solvencia crediticia. En este caso, se lleva a cabo una toma de
            decisiones automatizada.
          </li>
          <li>
            Gestionar y tramitar las formas de pago del préstamo solicitado, a
            través de los canales habilitados al efecto, en particular mediante
            ingreso o transferencia bancaria.
          </li>
          <li>
            Presentar cualquier reclamación en caso de retraso en el pago y/o
            impago, utilizando los datos de contacto facilitados.
          </li>
          <li>
            Gestionar y tramitar las formas de pago del préstamo solicitado, a
            través de los canales habilitados al efecto, en particular, mediante
            ingreso o transferencia bancaria.
          </li>
          <li>
            Cumplir con las obligaciones legalmente establecidas y las
            solicitudes de información de las autoridades competentes. Por
            ejemplo: verificación de la identidad o verificación de los datos
            bancarios comunicados de conformidad con lo dispuesto en la
            normativa sobre prevención del blanqueo de capitales y financiación
            del terrorismo o de ejecución, prevención del fraude, así como de
            otras actividades delictivas.
          </li>
          <li>
            Mantener la seguridad de la infraestructura proporcionada a nuestros
            Clientes.
          </li>
          <li>
            Permitir la gestión administrativa de la actividad de la empresa.
          </li>
          <li>
            Permitir el cumplimiento de las obligaciones contables y comerciales
            de la empresa.
          </li>
          <li>Envío de comunicaciones comerciales.</li>
          <li>Recabar la opinión de las partes interesadas.</li>
          <li>
            Ceder, transferir o conceder en garantía, parcial o totalmente, los
            derechos de crédito (incluidos los de reclamación de pagos
            atrasados) a favor de Nébula que se deriven de nuestros contratos
            celebrados.
          </li>
          <li>Realizar análisis estadísticos del fraude y el riesgo.</li>
          <li>
            Cumplimiento de las obligaciones legales y reglamentarias aplicables
            a Nébula.
          </li>
          <li>
            Informar a otras entidades de los impagos de un posible cliente
            incorporando los datos de deudas ciertas, vencidas y exigibles a los
            sistemas de información de solvencia financiera (EXPERIAN-FICHERO
            BADEXCUG).
          </li>
        </ul>
        <div class="desc">
          Los fines complementarios no son esenciales para la prestación de
          servicios, pero nos ayudan a mejorar y ofrecerle un mejor servicio:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Ofrecer por parte de Nébula productos y/o servicios similares a los
            solicitados previamente.
          </li>
          <li>
            Ofrecer productos y/o servicios de terceros, incluidas empresas de
            nuestro grupo, con el consentimiento previo del usuario.
          </li>
          <li>
            Resolver incidencias y mejorar el servicio y la calidad de nuestros
            productos y servicios.
          </li>
          <li>
            Gestionar su participación en diversas actividades promocionales
            (por ejemplo, sorteos, concursos) organizadas por Nébula.
          </li>
          <li>
            Tratamiento de datos con fines comerciales y publicitarios
            relacionados con los productos y servicios ofrecidos por Nébula y/o
            partes vinculadas, utilizando canales de comunicación como teléfono,
            SMS, sistemas de mensajería instantánea (por ejemplo, WhatsApp) y/o
            correo electrónico.
          </li>
          <li>
            Evaluar el servicio y la satisfacción del cliente, ya sea
            directamente por Nébula o a través de terceros procesadores de
            datos.
          </li>
          <li>
            Analizar, gestionar y transferir las reclamaciones y demandas
            extrajudiciales a terceros proveedores responsables de su
            tramitación.
          </li>
          <li>
            Atender las consultas de los clientes sobre nuestros servicios a
            través de canales de comunicación como el teléfono, los SMS, los
            sistemas de mensajería instantánea (por ejemplo, WhatsApp) y/o el
            correo electrónico.
          </li>
          <li>
            Tratamiento de datos con fines administrativos internos del grupo.
          </li>
          <li>
            Adaptación del sitio web y/o la aplicación al comportamiento de los
            usuarios durante las interacciones mediante el análisis de clics,
            tipos de dispositivos, movimientos del ratón y mapas de calor.
          </li>
        </ul>
        <div class="desc">
          7. ¿Cuál es la legitimación para el tratamiento de sus datos?
        </div>
        <div class="desc">
          La legitimación para el tratamiento de sus datos es su propio
          consentimiento, inequívoco, informado y expreso, en aquellos casos en
          que sea legalmente exigible, sin que, en ningún caso, la retirada del
          mismo condicione la ejecución de otro tratamiento cuya legitimación
          sea distinta, y sin que dicha retirada afecte a la licitud del
          tratamiento anterior a la retirada de este (artículo 6.1.a) del GDPR);
          y la ejecución del contrato de prestación de servicios o de medidas
          precontractuales y/o de compraventa de los productos correspondientes,
          celebrado por usted (artículo 6.1.b) del GDPR).
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Gestionar y tramitar las solicitudes y/o peticiones realizadas por
            el Usuario, incluyendo todas las dudas, consultas, quejas y/o
            reclamaciones que el Usuario pueda plantear a través de cualquiera
            de los canales habilitados al efecto, incluido el telefónico:
            consentimiento del usuario (artículo 6.1.a) RGPD).
          </li>
          <li>
            Gestión y tramitación de la solicitud de préstamo, incluidas las
            comprobaciones preliminares necesarias para aprobar el préstamo en
            línea, incluido el análisis de la solvencia, el riesgo y la
            solvencia crediticia: interés legítimo del responsable del
            tratamiento (artículo 6.1.f) del RGPD).
          </li>
          <li>
            Gestionar y tramitar las formas de pago del préstamo solicitado, a
            través de los canales habilitados al efecto, en particular mediante
            ingreso bancario o transferencia bancaria: ejecución del contrato
            (artículo 6.1.b) RGPD).
          </li>
          <li>
            Para realizar cualquier reclamación en caso de morosidad y/o impago,
            haciendo uso de los datos de contacto facilitados: interés legítimo
            del responsable del tratamiento y ejecución del contrato (artículos
            6.1.a) y b) RGPD).
          </li>
          <li>
            Gestionar y tramitar las formas de pago del préstamo solicitado, a
            través de los canales habilitados al efecto, en particular mediante
            ingreso bancario o transferencia bancaria: ejecución del contrato
            (artículo 6.1.b) RGPD).
          </li>
          <li>
            Cumplir con obligaciones legalmente establecidas y solicitudes de
            información de las autoridades competentes. Por ejemplo:
            verificación de la identidad o verificación de los datos bancarios
            comunicados por de conformidad con la normativa sobre prevención del
            blanqueo de capitales y financiación del terrorismo o de ejecución,
            prevención del fraude, así como de otras actividades delictivas:
            cumplimiento de una obligación legal (artículo 6.1.c) GDPR).
          </li>
          <li>
            Para permitir el cumplimiento de las obligaciones contables y
            comerciales de la empresa: cumplimiento de una obligación legal
            (artículo 6, apartado 1, letra c) del GDPR).
          </li>
          <li>
            Permitir la gestión administrativa de la actividad de la empresa:
            interés legítimo (artículo 6, apartado 1, letra f) del RGPD).
          </li>
          <li>
            Envío de comunicaciones comerciales. Respecto de los interesados que
            hayan solicitado información sobre los servicios de la Sociedad a
            través del sitio web o de cualquiera de los otros canales de
            contacto establecidos al efecto: consentimiento expreso del usuario
            (artículo 6.1.a) RGPD).
          </li>
        </ul>
        <div class="desc-li">
          8. ¿Durante cuánto tiempo se tratarán sus datos personales?
        </div>
        <div class="desc">
          Con carácter general, los datos facilitados se conservarán, durante el
          tiempo necesario, para cada una de las finalidades mencionadas en la
          cláusula 5.
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Gestionar y tramitar las solicitudes y/o peticiones realizadas por
            el Usuario, incluyendo todas las dudas, consultas, quejas y/o
            reclamaciones que el Usuario pueda plantear a través de cualquiera
            de los canales habilitados al efecto, incluido el telefónico:
            durante un plazo de 5 años, salvo que el Usuario ejercite su derecho
            de supresión.
          </li>
          <li>
            Gestión y tramitación de la solicitud de préstamo, incluidas las
            comprobaciones preliminares necesarias para aprobar el préstamo en
            línea, incluidos los análisis de solvencia, riesgo y crédito. En
            este caso, la toma de decisiones automatizada puede llevarse a cabo:
            durante un período de 5 años, a menos que ejerza su derecho de
            supresión.
          </li>
          <li>
            Realizar cualquier reclamación en caso de demora y/o impago,
            utilizando los datos de contacto facilitados: durante la vigencia
            del contrato de préstamo o, en todo caso, mientras el impago o la
            deuda sigan pendientes. Posteriormente, dicha información será
            almacenada durante un periodo de 10 años en cumplimiento de la
            LPBC-FT.
          </li>
          <li>
            Gestionar y tramitar las formas de pago del préstamo solicitado, a
            través de los canales habilitados al efecto, en particular mediante
            ingreso bancario o transferencia bancaria: durante la vigencia del
            contrato de préstamo. Posteriormente, esta información se conservará
            durante un periodo de 10 años en cumplimiento de la LPBC-FT.
          </li>
          <li>
            Cumplir con las obligaciones legalmente establecidas. Por ejemplo:
            solicitar y archivar información relacionada con el cumplimiento de
            la normativa de prevención del blanqueo de capitales y financiación
            del terrorismo o de ejecución, prevención del fraude, así como de
            otras actividades delictivas: durante los plazos legalmente
            establecidos (10 años).
          </li>
          <li>
            Permitir el cumplimiento de las obligaciones contables y mercantiles
            de la empresa: durante los plazos legalmente establecidos (6 años).
          </li>
          <li>
            Para permitir la gestión administrativa de la actividad de la
            empresa: durante la vigencia del contrato de préstamo y hasta que se
            hayan abonado el importe del préstamo y los intereses acordados.
            Posteriormente, dicha información se conservará durante un periodo
            de 10 años en cumplimiento de la LPBC-FT.
          </li>
          <li>
            Envío de comunicaciones comerciales. Indefinidamente, hasta que
            manifieste su oposición al citado tratamiento, derecho que podrá
            ejercer en cualquier momento.
          </li>
        </ul>
        <div class="desc-li">9. ¿A quién se comunicarán sus datos?</div>
        <div class="desc">
          Sus datos serán comunicados dentro del Grupo, para el control
          económico y administrativo de los préstamos concedidos por las
          distintas empresas del Grupo. Además, estos datos se conservarán en
          los servidores de la citada sociedad matriz durante los periodos de
          tiempo mencionados. Además, sus datos podrán ser comunicados a:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Juzgados y Tribunales, en los casos previstos por la ley, con motivo
            del cumplimiento de una obligación legal, o del ejercicio del
            derecho a la tutela judicial efectiva en caso de reclamación.
          </li>
          <li>
            Empresas gestoras de sistemas de información crediticia: en caso de
            impago del préstamo, Nébula se reserva el derecho, siempre que se
            cumplan los requisitos establecidos por la normativa aplicable, de
            comunicar el impago a los sistemas de información crediticia
            (incluidos los ficheros de solvencia y crédito).
          </li>
          <li>
            Bufetes de abogados para servicios de reclamaciones judiciales.
          </li>
          <li>
            Proveedores de servicios de verificación de identidad y análisis de riesgos
          </li>
          <li>
            Terceros acreedores, como consecuencia de la venta o cesión de
            créditos, cumpliendo con todos los requisitos establecidos por la
            ley. Esta comunicación se sustenta en el interés legítimo del
            tercero acreedor que tiene en el cobro de los créditos concedidos.
          </li>
          <li>
            Entidades de pago que prestan servicios de pago, incluidas: UNNAX
            REGULATORY SERVICES, EDE, SLU.
          </li>
        </ul>
        <div class="desc">
          Si durante el proceso de solicitud, usted acepta voluntariamente la
          validación de su cuenta bancaria a través del servicio de "Agregación
          de Información de Cuentas" ("openbanking") ofrecido por UNNAX,
          concediendo acceso a sus datos financieros, usted autoriza a Nébula a
          acceder (a través del servicio proporcionado por UNNAX) a la
          información relativa a las transacciones realizadas durante los
          últimos 90 días de acuerdo con los fines enumerados en la cláusula 4
          de la presente Política y de conformidad con la legislación aplicable
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Proveedores Cloud: Nébula contrata su infraestructura virtual basada
            en un modelo de Cloud Computing a través de Amazon Web Services
            (AWS), en servidores ubicados dentro del Espacio Económico Europeo.
          </li>
          <li>
            Sus datos podrán ser comunicados a las administraciones u organismos
            reguladores o supervisores que, en virtud de sus competencias
            legales, lo soliciten.
          </li>
          <li>
            Aparte de los anteriores, pueden tener acceso a sus datos terceros,
            incluidos los Encargados del Tratamiento del Responsable del
            Tratamiento, como proveedores de servicios de alojamiento
            informático, proveedores de verificación de datos bancarios,
            proveedores de servicios de pago como Unnax, Experian, o proveedores
            de información sobre solvencia crediticia como Equifax. Estos
            procesadores de datos han firmado los correspondientes acuerdos de
            procesamiento de datos con Nébula, que incluyen las garantías
            necesarias según lo establecido en el artículo 28 del Reglamento
            General de Protección de Datos. Las categorías de procesadores de
            datos incluyen:
          </li>
          <ul class="protocol-list protocol-list-unordered">
            <li>Servicios de auditoría;</li>
            <li>
              Servicios jurídicos y de cobro de deudas, tanto judiciales como
              extrajudiciales;
            </li>
            <li>Servicios de pago;</li>
            <li>Servicios de publicidad y comunicación;</li>
            <li>Encuestas y servicios de calidad;</li>
            <li>
              Servicios de atención telefónica, centros de llamadas, gestión de
              siniestros y apoyo operativo;
            </li>
            <li>
              Servicios informáticos (incluidos sistemas y seguridad de la
              información, ciberseguridad, sistemas de información,
              arquitectura, alojamiento, procesamiento de datos y
              mantenimiento);
            </li>
            <li>Servicios de telecomunicaciones;</li>
            <li>Servicios postales y de mensajería;</li>
            <li>
              Proveedores de servicios de análisis del comportamiento del
              usuario, como herramientas que registran las interacciones dentro
              de la aplicación (clics, desplazamiento, etc.);
            </li>
          </ul>
        </ul>
        <div class="desc">
          Además, en caso de venta, fusión, consolidación, cambio en el control
          corporativo, transferencia de activos sustanciales, reorganización o
          liquidación de Nebula, podemos, a nuestra discreción, transferir,
          vender o ceder la información recopilada en el sitio web a una o más
          partes relevantes.
        </div>

        <div class="desc-li">
          10. ¿Se realiza alguna transferencia internacional de datos?
        </div>
        <div class="desc">
          Los datos personales pueden ser transferidos internacionalmente fuera
          del Espacio Económico Europeo (EEE) a terceros (proveedores de
          servicios) y procesadores de datos, incluyendo a la empresa matriz del
          grupo, cuando dicha comunicación sea necesaria para la correcta
          prestación de los servicios. En los casos en que el país de destino no
          disponga de una decisión de adecuación de la UE, se ha firmado con la
          empresa en cuestión para garantizar la seguridad de los datos, las
          cláusulas contractuales tipo, donde Nébula adoptará las medidas
          correspondientes a para garantizar un nivel adecuado de protección
          cuando el proveedor de servicios o encargado del tratamiento no haya
          sido declarado de ofrecer una protección equivalente a la de la Unión
          Europea.
        </div>
        <div class="desc">
          No está prevista ninguna otra transferencia de sus datos a países
          fuera del EEE.
        </div>

        <div class="desc-li">
          11. ¿Se realiza una toma de decisiones automatizadas?
        </div>
        <div class="desc">
          En el proceso de análisis previo a la concesión de un préstamo se
          toman decisiones automatizadas, es decir, sin participación humana.
          Utilizamos este mecanismo para tomar decisiones relativas a la
          concesión de un préstamo solicitado por varias razones, que se
          describen a continuación:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Este sistema de toma de decisiones nos permite adoptar decisiones
            con un mayor grado de coherencia, justicia y equidad, reduciendo,
            por ejemplo, la posibilidad de discriminación contra un solicitante
            o la posibilidad de error humano o abuso de poder si interviniera
            una sola persona.
          </li>
          <li>
            También nos permite reducir el riesgo de que los clientes incumplan
            sus obligaciones de pago.
          </li>
          <li>
            Nos permite tomar decisiones en menos tiempo que un proceso basado
            en humanos y mejora la eficiencia del proceso, lo que es esencial
            para el tipo de préstamos que ofrecemos y nuestro modelo de negocio.
          </li>
        </ul>
        <div class="desc">
          En nuestro caso, esta toma de decisiones automatizada con efectos
          jurídicos nos permite evaluar su solvencia, verificar su identidad y
          detectar o prevenir el fraude, así como permitir el cumplimiento de la
          normativa relativa a la prevención del blanqueo de capitales y de la
          financiación del terrorismo.
        </div>
        <div class="desc">
          La aceptación o el rechazo de una solicitud suele ser automática y se
          basa en distintos factores que tenemos en cuenta en nuestro proceso de
          toma de decisiones. En consecuencia, su solicitud puede ser rechazada
          automáticamente. Revisamos y mejoramos periódicamente nuestras normas
          y algoritmos para garantizar la equidad y la eficacia. Además, los
          métodos de calificación crediticia utilizados se comprueban
          periódicamente para garantizar que siguen siendo justos, eficaces e
          imparciales.
        </div>
        <div class="desc">
          Las decisiones automatizadas y la elaboración de perfiles pueden
          basarse en cualquier tipo de datos, por ejemplo:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Los datos facilitados por usted en su solicitud, así como cualquier
            documentación adicional que podamos pedirle.
          </li>
          <li>Información obtenida de su banco, previo consentimiento.</li>
          <li>
            Información obtenida de ficheros de crédito y solvencia o registros
            públicos.
          </li>
          <li>
            Información sobre préstamos anteriores que nos haya solicitado.
          </li>
          <li>
            Las decisiones automatizadas y la elaboración de perfiles pueden
            basarse en cualquier tipo de datos, por ejemplo:
          </li>
          <li>
            Los datos facilitados por usted en su solicitud, así como cualquier
            documentación adicional que podamos pedirle.
          </li>
          <li>Información obtenida de su banco, previo consentimiento.</li>
          <li>
            Información obtenida de ficheros de crédito y solvencia o registros
            públicos.
          </li>
          <li>
            Información sobre préstamos anteriores que nos haya solicitado.
          </li>
          <li>
            Debe saber que, si recibe una decisión basada en una decisión
            automatizada, incluida la elaboración de perfiles, tiene los
            siguientes derechos:
          </li>
          <li>
            Derecho a recibir explicaciones adecuadas sobre la base de la
            decisión adoptada;
          </li>
          <li>Derecho a la intervención humana para reevaluar la decisión;</li>
          <li>El derecho a expresar su opinión.</li>
        </ul>
        <div class="desc">
          Para ejercer los derechos mencionados, debe ponerse en contacto con
          nosotros utilizando los datos de contacto que figuran en la sección
          sobre el ejercicio de sus derechos.
        </div>
        <div class="desc">
          Lo anterior no implica que, en determinadas ocasiones, en función del
          tipo de préstamo solicitado, la toma de decisiones pueda implicar la
          intervención humana previa a la decisión de conceder un préstamo.
        </div>

        <div class="desc-li">
          12. ¿Cuáles son sus derechos en materia de protección de datos?
        </div>
        <div class="desc">
          En la medida en que Nébula procese sus datos personales, usted tiene
          derecho a solicitar:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            Acceso: El interesado tendrá derecho a obtener del responsable del
            tratamiento confirmación de si se están tratando o no datos que le
            conciernan, así como información detallada sobre determinados
            aspectos del tratamiento que se esté llevando a cabo.
          </li>
          <li>
            Rectificación: El interesado tendrá derecho a obtener la
            rectificación de los datos personales inexactos que le conciernan o
            a que se completen los datos personales incompletos.
          </li>
          <li>
            Supresión: El interesado tendrá derecho a solicitar la supresión de
            sus datos personales, en todo caso la supresión estará sujeta a los
            límites establecidos en la norma reguladora.
          </li>
          <li>
            Limitación del tratamiento: El interesado tendrá derecho a solicitar
            la limitación del tratamiento de sus datos personales.
          </li>
          <li>
            Oposición al tratamiento: En determinadas circunstancias y por
            motivos relacionados con su situación particular, los interesados
            podrán oponerse al tratamiento de sus datos. Nébula dejará de tratar
            los datos, salvo por motivos legítimos o el ejercicio o la defensa
            de posibles reclamaciones.
          </li>
          <li>
            Derecho a la portabilidad de los datos: Es decir, tienes derecho a
            recibir los datos personales que te conciernan, que hayas facilitado
            a un responsable del tratamiento, en un formato estructurado, de uso
            común y lectura mecánica y a transmitirlos a otro responsable del
            tratamiento.
          </li>
          <li>
            Derecho a retirar en cualquier momento el consentimiento que haya
            podido otorgar: Tiene derecho a retirar su consentimiento para el
            tratamiento de sus datos en cualquier momento, sin que ello afecte a
            la legalidad del tratamiento basado en el consentimiento previo a su
            retirada.
          </li>
        </ul>
        <div class="desc">
          Los citados derechos podrán ser ejercitados mediante solicitud
          dirigida a Nébula Finance, S.A. a través de la dirección de correo
          electrónico
          <span class="mark-text">dpo@prestalight.com</span>, indicando
          claramente el derecho que desea ejercitar y con la referencia:
          "Protección de Datos". Deberá facilitarnos una copia de su DNI para
          que podamos verificar su identidad. Tramitaremos la solicitud y le
          informaremos de las acciones realizadas en el plazo de un mes desde su
          recepción. Si fuera necesario un plazo adicional debido a la
          complejidad o al volumen de las solicitudes, este plazo podrá
          ampliarse hasta dos meses más, previa notificación a usted.
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>Delegado de Protección de Datos: Grupo Ático 34 S.L.</li>
        </ul>
        <div class="desc-li">13. Autoridad de control</div>
        <div class="desc">
          Si considera que se ha realizado algún tratamiento indebido en el
          tratamiento de sus datos, puede solicitar la tutela de la Agencia
          Española de Protección de Datos mediante la presentación de la
          correspondiente reclamación: www.aepd.es
          <!-- <span class="link mark-text" @click="openLink('http://www.aepd.es')"
            >www.aepd.es</span
          > -->
        </div>

        <div class="desc-li">14. Información de contacto</div>
        <div class="desc">
          Para contactar con nosotros para cualquier consulta puede hacerlo a la
          siguiente dirección de correo electrónico:
          <span class="mark-text">{{ emailNo }}</span>
        </div>

        <div class="desc-li">15. Medidas de seguridad</div>
        <div class="desc">
          Nébula ha adoptado los niveles de seguridad de protección de los datos
          personales legalmente requeridos, y ha instalado todos los medios y
          medidas técnicas a su alcance para evitar la pérdida, mal uso,
          alteración, acceso no autorizado y robo de los datos personales
          facilitados a Nébula Finance, S.A.. No obstante, el usuario debe ser
          consciente de que las medidas de seguridad en Internet no son
          inexpugnables.
        </div>

        <div class="desc-li">16. Consentimiento del usuario</div>
        <div class="desc">
          Usted reconoce haber leído y aceptado explícitamente la presente
          Política de Privacidad cuando la base jurídica para el tratamiento de
          sus datos sea su consentimiento. Usted tiene derecho a retirar su
          consentimiento en cualquier momento. La retirada del consentimiento no
          afectará a la legalidad del tratamiento efectuado con anterioridad a
          su retirada. Usted se compromete a indemnizar a Nébula frente a
          cualquier posible reclamación, multa o sanción que pudiera derivarse
          del incumplimiento de las obligaciones establecidas en la presente por
          su parte política.
        </div>

        <div class="desc-li">17. Enlaces a otros sitios web</div>
        <div class="desc">
          Nuestro sitio web y nuestra aplicación móvil pueden contener enlaces a
          sitios web de terceros que no están gestionados por Nébula. Como tal,
          Nébula no ejerce control sobre estos sitios web y no es responsable de
          la información a la que puedan tener acceso. Le recomendamos que
          visite directamente estos sitios web para consultar sus políticas de
          privacidad en las que se ofrecen detalles sobre la protección de
          datos, las medidas de seguridad, las prácticas de recopilación de
          datos y las disposiciones sobre transmisión de datos.
        </div>

        <div class="desc-li">18. Modificaciones de esta política</div>
        <div class="desc">
          Nos reservamos el derecho a modificar esta política de vez en cuando
          actualizando nuestro sitio web. Le rogamos que visite el sitio web con
          regularidad y consulte nuestra política de privacidad vigente. En caso
          de que alguna cláusula de la presente Política de Privacidad fuera
          anulada o considerada nula, los restantes términos y condiciones no se
          verán afectados, conservando su plena validez y eficacia, de
          conformidad con la normativa vigente en cada momento.
        </div>
        <div class="desc">
          Al utilizar nuestro servicio, usted reconoce lo siguiente:
        </div>
        <ul class="protocol-list protocol-list-unordered">
          <li>
            le hemos presentado de forma destacada esta Política de Privacidad
            en su totalidad.
          </li>
          <li>
            ha leído y comprendido íntegramente las normas de tratamiento de
            expuestas en la política de privacidad.
          </li>
        </ul>
        <div class="desc">
          Basándose en el entendimiento anterior, por la presente nos autoriza
          expresamente a procesar los datos pertinentes de conformidad con los
          términos de la declaración. Esta autorización forma parte integrante
          de los derechos y obligaciones entre usted y nosotros.
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import { channelMethods, postToApp } from '@/utils/channelMethod';
import { formatDateTime, getCredential, getKey } from '@/utils';
import {
  officialAddress,
  email,
  website,
  companyName
} from '@/utils/orderConfig';
import { _fetchJustifyLiquidate } from '@/api/help';

export default {
  name: 'privacyPage',
  methods: {
    addressL: officialAddress,
    emailL: email,
    miWebsite: website,
    formatDateTime,
    companyNameL: companyName
  },
  props: {
    type: String
  },
  setup(props: any) {
    const loading = ref(false);
    const route = useRoute();

    const dialogMode = computed(() => {
      return true;
    });

    const isInApp = computed(() => {
      return getCredential();
    });

    const isFromPermission = computed(() => {
      return route.query.source == 'permission';
    });

    const handleBackClick = () => {
      router.back();
    };

    const handleScroll = (event: any) => {
      if (dialogMode.value) {
        let scrollTop = event.target.scrollTop;
        let scrollHeight = event.target.scrollHeight;
        let clientHeight = event.target.clientHeight;
        console.log('onScroll', scrollTop, scrollHeight, clientHeight);
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          console.log('onScrollEnd');
          postToApp(channelMethods.scrollToEnd, 'true');
        }
      }
    };

    const openLink = (url: any) => {
      window.open(url, '_blank');
    };

    const resultData = ref<any>();

    const emailNo = computed(() => {
      return (
        resultData.value?.filter((item: any) => item.expand === '3')[0]
          ?.monitor ?? 'clientes@prestalight.com'
      );
    });

    const servicePhoneNo = computed(() => {
      return (
        resultData.value?.filter((item: any) => item.expand === '2')[0]
          ?.monitor ?? '917905850'
      );
    });

    const onLoadServiceInfo = () => {
      _fetchJustifyLiquidate({})
        .then((res: any) => {
          // console.log('_repaymentAgreementInfo: ', res['justifyLiquidate']);
          const resultList = res['justifyLiquidate'];
          if (resultList) {
            resultData.value = resultList;
          }
        })
        .catch(err => {})
        .finally(() => {});
    };

    const isIOS = computed(() => {
      return props.type === 'ios';
    })

    onMounted(() => {
      document.title = 'User Privacy Agreement';
      // postToApp(channelMethods.darkMode, 'default');
      onLoadServiceInfo();
    });

    return {
      loading,
      isInApp,
      dialogMode,
      isFromPermission,
      isIOS,
      handleBackClick,
      handleScroll,
      openLink,
      emailNo,
      servicePhoneNo
    };
  }
};
</script>

<style lang="scss" scoped>
.list-container {
  width: 100vw;
  height: 100vh;
  max-width: $max-width;
  position: relative;

  display: flex;
  flex-direction: column;

  .back-btn {
    position: absolute;
    left: 30px;
    top: 28px;

    padding: 10px;


    .button-icon {
      width: 36px; /* Adjust icon size */
      height: 26px; /* Adjust icon size */
    }
  }
}
</style>
